import InstantPlays from './InstantPlays';
export default InstantPlays;
